<template>
<div class="swaychat-chathead" @click="toggleMinimize" :class="{
    'swaychat-hide' : isPopout || !isMinimize || isBootHidden
    }" :style="{ 'background-color': getPrimaryBg }">

  <!-- agent state -->
  <div v-if="getViewState == 3 && getAgent" class="swaychat-chathead-img">
    <div class="swaychat-badge swaychat-bounceIn" v-if="getUnread">{{  getUnread }}</div>
    <div class="swaychat-chathead-ini"><span :style="{ 'background-color' : getAgent.agentBg ? getAgent.agentBg : '' }">P</span></div>
    <div class="swaychat-chathead-src" v-if="getAgent.avatar">
      <img :src="makeAliasHost(getAgent.avatar)" style="display:none" onload="this.style.display = ''" class="swaychat-bounceIn">
      <div class="swaychat-bubblehead-pulse" :style="{ 'background-color': getPrimaryBg }"></div>
    </div>
  </div>

  <div v-else class="swaychat-chathead-img" :style="{ 'background-color': getPrimaryBg }">
    <div class="swaychat-chathead-src" :style="{ 'background-color': getPrimaryBg }">
      <img :src="makeAliasHost(getDefaultImg)" style="display:none" :style="{ 'background-color' : getAvatarBg }" onload="this.style.display = ''" class="swaychat-bounceIn">
      <div class="swaychat-bubblehead-pulse" :style="{ 'background-color': rgba }"></div>
    </div>
  </div>

</div>
</template>

<script>
import {
  mapGetters
} from 'vuex'

import {
  hexToRGB
} from '../utils/helpers'

export default {
  computed: {
    rgba() {
      return hexToRGB(this.getPrimaryBg,0.375)
    },
    ...mapGetters([
      'getStartUpMode',
      'isMinimize',
      'isPopout',
      'getDefaultImg',
      'getUnread',
      'getAvatarBg',
      'getPrimaryBg',
      'getViewState',
      'isBootHidden',
      'getAgent'
    ])
  },
  methods: {
    toggleMinimize() {
      this.$store.dispatch('toggleMinimize', true)
    },
    makeAliasHost (url) {
      const host = '@@UPLOADCARE_ALIAS_HOST';

      return url && url.indexOf('www.ucarecdn.com') !== -1 && host
        ? url.replace('www.ucarecdn.com', host)
        : url;
    }
  }
}
</script>
